import { HStack, Menu } from "@chakra-ui/react"
import { useRef } from "react"
import type { ComponentProps } from "react"
import Pathicon from "../pathicon/Pathicon"
import FilterOptions from "./FilterOptions"
import { FilterOption, Filters } from "./types"

type OnFilterChange = (filterOptions: FilterOption[]) => void

function FilterMenuItem({
  filter,
  value,
  onChange
}: {
  filter: Filters[keyof Filters]
  value: FilterOption[] | null
  onChange: OnFilterChange
}) {
  const itemRef = useRef<HTMLDivElement>(null)

  return (
    <Menu.Root
      positioning={{ placement: "right", strategy: "absolute" }}
      closeOnSelect={false}
    >
      <Menu.Trigger asChild>
        <HStack ref={itemRef}>
          <Pathicon icon={filter.icon} />
          <span>{filter.label}</span>
          <Pathicon icon="chevron-right" ml="auto" />
        </HStack>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content>
          <FilterOptions
            value={value ?? ([] as FilterOption[])}
            onChange={onChange}
          />
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}

export default FilterMenuItem
